<template>
  <main>
    <section>
      <h4>Introdução</h4>
      <p class="text-justify">
        Um universo de tema medieval, composto por um mundo quase todo coberto
        por água, com algumas ilhas, onde cada ilha é uma nação diferente e com
        grande diferença na paisagem de cada ilha, onde uma ilha pode ser um
        deserto e outra um paraíso tropical. A magia nesse universo é muito
        escassa, poucos conseguem manipulá-la.
      </p>
    </section>
    <hr />

    <section>
      <h4>História Principal</h4>
      <p class="text-justify">
        Desde a fundação desse universo que ele tem a mesma forma, sendo quase
        totalmente coberto por um mar gigante, feroz e com criaturas de
        proporções míticas, fazendo assim com que seja muito arriscado cruzar os
        mares. Mas cerca de 200 anos atrás começou a
        <strong>Era das Grandes Navegações</strong>, onde todas as nações de
        pouco em pouco foram tendo interesse de desbravar os mares para
        estabelecer contato com outras nações e descobrir novas terras e
        tesouros.
      </p>

      <p class="text-justify">
        Depois de diversos anos, algumas nações se tornaram mais poderosas,
        conquistaram novos terrenos e dominaram a economia mundial por causa dos
        seus marinheiros. Entre essas nações, as mais influentes são:
        <strong>Bocco, a Ilha do Fogo</strong>,
        <strong>Jaal, o Deserto de Gelo</strong> e
        <strong>Elyath, a Selva de Pedra</strong>.
      </p>

      <p class="text-justify">
        <strong>Kyr</strong>, o capitão de um grupo de soldados de
        <strong>Jaal</strong> estava no meio de uma missão em
        <strong>Elyath</strong> quando a capital da nação sofreu um ataque de um
        grupo pirata. Para conseguir salvar seus companheiros ele teve de
        sacrificar a missão que lhe foi dada e por isso foi expulso do exército
        e se tornou um rebelde. Em suas viagens como rebelde conheceu um
        misterioso pirata chamado <strong>Zyon</strong> que falava muito de
        magia e de uma espada forjada por seres de outro universo.
        <strong>Kyr</strong> viajou por alguns meses com ele e ele lhe ensinou
        sobre como manipular a magia e depois de algum tempo disse que havia de
        partir sozinho para encontrar a tal espada e
        <strong>Kyr</strong> continua sua vida de rebelde como mercenário.
      </p>

      <p class="text-justify">
        Alguns anos se passam sem muito acontecendo no mundo.
        <strong>Kyr</strong> se junta ao bando pirata de
        <strong>Bellatrix</strong>, a maior pirata que já existiu e ela ouve
        rumores que a ilha <strong>Jaal</strong> foi extinta do mapa e os
        rumores dizem que foi apenas uma pessoa que provocou isso. Intrigada ela
        e seu bando decidem viajar para <strong>Jaal</strong>, confirmando que
        não existe mais nenhum sinal da ilha.
      </p>

      <p class="text-justify">
        A notícia que um tirano está tentando tomar o controle de todas as
        nações se espalha e eles descobrem que esse tirano é na verdade
        <strong>Zyon</strong>, que está totalmente diferente de como
        <strong>Kyr</strong> lembrava. Ele conseguiu a espada de qual falava,
        mas a espada parece ter consumido sua alma. <strong>Zyon</strong> cria
        sua fortaleza na ilha <strong>Bocco</strong> e um ser misterioso chamado
        <strong>Lynx</strong> aparece para ajudar <strong>Zyon</strong>. Todas
        as nações e os bandos piratas precisam se juntar para conseguir se
        livrar do poderoso tirano e seu ajudante misterioso.
      </p>
    </section>
    <hr />

    <characters-list :universe="universe" />
  </main>
</template>

<script>
import CharactersList from '../CharactersList'

export default {
  name: 'era-sombria',

  props: {
    universe: { type: Object, required: true },
  },

  components: { CharactersList },
}
</script>
